module.exports = "/_next/static/images/eeb1484773519f2d2b0a6c1e0923a162-hands-holding-cards-xs@2x.jpg.webp";